import { Component, HostBinding, Input } from '@angular/core';

export enum BadgeSize {
  SMALL = '',
  BIG = 'big'
}

@Component({
  selector: 'mui-bell-icon',
  templateUrl: './mui-bell-icon.component.html',
  styleUrls: ['./mui-bell-icon.component.scss']
})
export class MuiBellIconComponent {
  /**
   * Provide an accessible label for the bell icon (e.g. "You have 16 notifications").
   */
  @Input()
  label: string | null = null;

  @HostBinding('class.is-open')
  isOpenClass = false;

  @HostBinding('class.badge-big')
  isBadgeClass = false;

  protected _count = 0;

  @Input()
  set isOpen(value: boolean) {
    this.isOpenClass = value;
  }


  @Input()
  set badgeSize(value: BadgeSize) {
    if (value === BadgeSize.BIG) {
      this.isBadgeClass = true;
    }
  }

  @Input()
  set count(value: number) {
    if (this.isAnimating() && this._count !== value) {
      this._count = 0;
      setTimeout(() => {
        this._count = value;
      }, 50);
    } else {
      this._count = value;
    }
  }

  isAnimating() {
    return this._count > 0;
  }

}
